<template>
  <div class="chart-container">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

export default {
  name: 'LineChart',
  props: {
    data: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: '#128078'
    }
  },
  setup(props) {
    const chartCanvas = ref(null)
    let chart = null

    const createChart = () => {
      if (chart) {
        chart.destroy()
      }

      const ctx = chartCanvas.value.getContext('2d')
      
      chart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: props.data.map(item => item.date),
          datasets: [{
            label: props.title,
            data: props.data.map(item => item.value),
            borderColor: props.color,
            backgroundColor: props.color + '20',
            borderWidth: 3,
            fill: true,
            tension: 0.4,
            pointBackgroundColor: props.color,
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 5,
            pointHoverRadius: 7
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              backgroundColor: 'rgba(10, 46, 43, 0.95)',
              titleColor: '#fff',
              bodyColor: '#fff',
              borderColor: props.color,
              borderWidth: 1,
              cornerRadius: 8,
              displayColors: false
            }
          },
          scales: {
            x: {
              grid: {
                color: 'rgba(255, 255, 255, 0.1)',
                drawBorder: false
              },
              ticks: {
                color: '#fff',
                font: {
                  size: 12
                }
              }
            },
            y: {
              grid: {
                color: 'rgba(255, 255, 255, 0.1)',
                drawBorder: false
              },
              ticks: {
                color: '#fff',
                font: {
                  size: 12
                },
                beginAtZero: true
              }
            }
          },
          elements: {
            point: {
              hoverBackgroundColor: props.color
            }
          }
        }
      })
    }

    onMounted(() => {
      createChart()
    })

    watch(() => props.data, () => {
      createChart()
    }, { deep: true })

    return {
      chartCanvas
    }
  }
}
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 200px;
  width: 100%;
}
</style> 